const CandidateSortKey = Object.freeze({
  Name: 'name',
  Recent: 'recent',
  Bookings: 'bookings',
  Preferred: 'preferred',
})

export const SortDirection = Object.freeze({
  Asc: 'asc',
  Desc: 'desc',
})

const SortEnum = Object.freeze({
  FirstNameAsc: 0,
  FirstNameDesc: 1,
  RecentDesc: 2,
  RecentAsc: 3,
  BookingsDesc: 4,
  BookingsAsc: 5,
  GroupLinksDesc: 6,
  GroupLinksAsc: 7,
})

export const FilterViews = Object.freeze({
  Sort: 'sort',
  ClientGroups: 'clientGroups',
  Certifications: 'certifications',
  Types: 'types',
})

const { Name, Recent, Bookings, Preferred } = CandidateSortKey
const { Asc, Desc } = SortDirection

const SortMap = Object.freeze({
  [Name]: {
    [Asc]: SortEnum.FirstNameAsc,
    [Desc]: SortEnum.FirstNameDesc,
  },
  [Recent]: {
    [Asc]: SortEnum.RecentAsc,
    [Desc]: SortEnum.RecentDesc,
  },
  [Bookings]: {
    [Asc]: SortEnum.BookingsAsc,
    [Desc]: SortEnum.BookingsDesc,
  },
  [Preferred]: {
    [Asc]: SortEnum.GroupLinksAsc,
    [Desc]: SortEnum.GroupLinksDesc,
  },
})

export const SortOptions = Object.freeze([
  { key: Name, i18nKey: 'candidateList.sort.options.name' },
  {
    key: Recent,
    i18nKey: 'candidateList.sort.options.recent',
  },
  {
    key: Bookings,
    i18nKey: 'candidateList.sort.options.bookings',
  },
  {
    key: Preferred,
    i18nKey: 'candidateList.sort.options.preferred',
  },
])

/**
 * Resolves a (sortKey, sortDir) pair to the BE Sort enum value.
 * Returns null when no sort is selected so the BE applies its grouping-aware default.
 */
export function resolveSortValue(sortKey, sortDir) {
  if (!sortKey) return null
  return SortMap[sortKey]?.[sortDir] ?? null
}
